const METHODS = {
  POST: "POST",
  GET: "GET",
  DELETE: "DELETE",
  PATCH: "PATCH",
  PUT: "PUT"
};

export const register = { url: "/auth/register", method: METHODS.POST };

export const login = { url: "/auth/login", method: METHODS.POST };

export const authGooglelogin = {
  url: "/auth/login/with-google-auth",
  method: METHODS.POST,
};

export const resetPassword = {
  url: "/auth/reset-password/{{token}}",
  method: METHODS.POST,
};

export const changePassword = {
  url: "/auth/change-password",
  method: METHODS.PATCH
}

export const forgotPassword = {
  url: "/auth/forgot-password",
  method: METHODS.POST,
};

export const createPost = { url: "/feeds/createFeed", method: METHODS.POST };

export const updatePost = { url: "/feeds/{{postId}}", method: METHODS.PATCH };

export const get_suscribers = { url: "/subscribe/user/{{userid}}", method: METHODS.GET };

export const get_channels = { url: "/message/channel/search", method: METHODS.GET };

export const getChannels = { url: "/message/channels", method: METHODS.GET };

export const getChannelMessages = { url: "/message/channel/{{channelId}}", method: METHODS.GET };

export const getUserChannelsWithMessages = { url: "/message/channelsWithMessages", method: METHODS.GET}

export const get_user_by_username = { url: "/users/fanxo/{{username}}", method: METHODS.GET, query: {} };

export const trackCreatorProfileView = {
  url: "/creator-discovery/profile-view",
  method: METHODS.POST,
};

export const myFeed = {
  url: "/feeds/feedsWithPagination",
  method: METHODS.GET,
};

export const postDelete = {
  url: "/feeds/{{postId}}",
  method: METHODS.DELETE,
}

export const requestPostRemoval = {
  url: "/feeds/{{postId}}/removal-request",
  method: METHODS.POST,
};

export const exploreList = {
  url: `/users/queryUsersWithPagination`,
  method: METHODS.GET,
};

export const updateUser = { url: "/users", method: METHODS.PATCH };

export const userDetails = { url: "/users", method: METHODS.GET };

export const userDetailsById = { url: "/users/{{userId}}", method: METHODS.GET };

export const fileUpload = { url: "/files/upload", method: METHODS.POST };

export const createOrder = { url: "/payment/new-order", method: METHODS.POST };

export const createGiftOrder = { url: "/gift/order", method: METHODS.POST };

export const verifyGiftPayment = { url: "/gift/verify", method: METHODS.POST };

export const getPushPublicKey = { url: "/push/public-key", method: METHODS.GET };

export const registerPushSubscription = { url: "/push/subscriptions", method: METHODS.POST };

export const removePushSubscription = { url: "/push/subscriptions", method: METHODS.DELETE };

export const createNewComment = {
  url: "/comments/create",
  method: METHODS.POST,
};

export const linkHandler = { url: "/likes/likeUnlike", method: METHODS.POST };

export const subscribeHandler = {
  url: "/subscribe/create",
  method: METHODS.POST,
};

export const authWithGoogle = {
  url: "/auth/google-auth",
  method: METHODS.POST,
};

export const getMessages = {
  url: "/message/list",
  method: METHODS.GET
}

export const newMessage = {
  url: "/message/create",
  method: METHODS.POST
}

export const newMessageChannel = {
  url: "/message/create-channel",
  method: METHODS.POST
}

export const getMemberShipDetails = {
  url: "/membership/{{creatorId}}",
  method: METHODS.GET
}

export const updateMemberShipDetails = {
  url: "/membership/update",
  method: METHODS.PUT
}

export const requestPayout = {
  url: "/payment/request-payout",
  method: METHODS.POST
}

export const requestedPayoutDetails = {
  url: "/payment/requested-payout-status",
  method: METHODS.GET
}

export const CheckSubscriptionStatus = {
  url: "/payment/checkSubscriptionStatus",
  method: METHODS.POST,
};

export const CancelSubscription = {
  url: "/payment/cancel-subscription",
  method: METHODS.POST,
};

export const markMessagesAsRead = {
  url: "/message/mark-read/{{channelSlug}}",
  method: METHODS.PUT,
};

export const getChannelUnreadMessages = {
  url: "/message/conversation/{{channelSlug}}",
  method: METHODS.GET,
  query: {},
  params: {}
};
